import HP from "../host";
import { PaginationParamsType } from "../types/common";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const EndorsementService = {
  create: async (body: object) => {
    return await api.post("/endorsement/create", body);
  },

  find: async (params: PaginationParamsType) => {
    return await api.get(
      `/endorsement/find?page=${params.page}&per_page=${params.per_page}&query=${
        params.query || ""
      }`
    );
  },

  findApproved: async () => {
    return await api.get(`/endorsement/find-approved`);
  },

  update: async (id: string, body: object) => {
    return await api.put(`/endorsement/update/${id}`, body);
  },

  delete: async (id: string) => {
    return await api.delete(`/endorsement/delete/${id}`);
  },
  findById: async (id: string) => {
    return await api.get(`/endorsement/find/${id}`);
  },
};
export default EndorsementService;
